const words = ["Validate", "Compare", "Profile", "Create", "Submit"];

export default function Marquee() {
  const row = [...words, ...words, ...words, ...words, ...words, ...words];
  return (
    <section
      aria-hidden="true"
      data-testid="marquee-section"
      className="border-y border-zinc-200 bg-white py-6 md:py-8 overflow-hidden"
    >
      <div className="marquee-track flex w-max gap-10">
        {row.map((w, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-10 font-heading text-3xl md:text-5xl font-medium tracking-tight text-zinc-900 whitespace-nowrap"
          >
            {w}
            <span className="text-[#0033A0]">✳</span>
          </span>
        ))}
      </div>
    </section>
  );
}
